class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('select');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.addEventListener('change', this.onButtonClick.bind(this))
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    // event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      });
    }
  }

  customElements.define('cart-remove-button', CartRemoveButton);

  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: "upsell_slider",
          section: "upsell_slider",
          selector: ".upsell_slider"
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.cart__footer'
        },
        {
          id: 'cart-item-count',
          section: 'ajax-cart',
          selector: '#cart-item-count'
        }
      ];
    }

    updateQuantity(line, quantity, name) {
      this.enableLoading(line);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });


      console.log('quantity change ...')
      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');
          const topBar = document.getElementById('ajax-top-message');
          const emptyState = document.querySelector('.ajax-is-empty');
          const upsellSlider = document.querySelector('.upsell_slider');

          if (topBar) topBar.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (upsellSlider) upsellSlider.classList.toggle('is-empty', parsedState.item_count === 0);
          if (parsedState.item_count === 0){
            emptyState.style.display = 'flex';
          } else {
            emptyState.style.display = 'none';
          }

          this.getSectionsToRender().forEach((section => {
            let elementToReplace = document.getElementById(section.id);
              if(elementToReplace){
                elementToReplace = elementToReplace.querySelector(section.selector);
              }


            if (elementToReplace){
              var sectionHtml = parsedState.sections[section.section]
              if(sectionHtml){
                elementToReplace.innerHTML =
                  this.getSectionInnerHTML(sectionHtml, section.selector);
              }
            }
          }));

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem =  document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();
          var productContainer = [...document.querySelectorAll('product-bundle-popup-container')];
          productContainer.forEach(container => {
          container.init();
          })
          document.dispatchEvent(new Event('bundle::trigger-slider-update'));
        })
    }

    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        document.getElementById(`Line-item-error-${line}`)
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document.getElementById('main-cart-items').classList.add('cart__items--disabled');
      // this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    }
  }

  customElements.define('cart-items', CartItems);

  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('ul');
      this.sliderItems = this.querySelectorAll('li');
      this.pageCount = this.querySelector('.slider-counter--current');
      this.pageTotal = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.progressBar = this.querySelector('.slider-progress-bar');

      if (!this.slider || !this.nextButton) return;

      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

      /** Desktop drag to scroll */
      let isDown = false;
      let startX;
      let scrollLeft;
      this.slider.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - this.slider.offsetLeft;
        scrollLeft = this.slider.scrollLeft;
      });
      this.slider.addEventListener('mouseleave', () => {
        isDown = false;
      });
      this.slider.addEventListener('mouseup', () => {
        isDown = false;
      });
      this.slider.addEventListener('mousemove', (e) => {
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.slider.offsetLeft;
        const walk = (x - startX) * 3;
        this.slider.scrollLeft = scrollLeft - walk;
      });
    }



    initPages() {
      const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
      if (sliderItemsToShow.length === 0) return;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);

      this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }



    update() {
      if (!this.pageCount || !this.pageTotal) {
        return;
      }
      let count = parseInt(this.pageCount.innerText)
      let total = parseInt(this.pageTotal.innerText)

      if(this.progressBar){
        let percentage = (count / total) * 100
        percentage = (percentage + '%')
        this.progressBar.style.width = percentage
      }

      if (!this.pageCount || !this.pageTotal) return;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

      if (this.currentPage === 1) {
        this.prevButton.setAttribute('disabled', true);
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.currentPage === this.totalPages) {
        this.nextButton.setAttribute('disabled', true);
      } else {
        this.nextButton.removeAttribute('disabled');
      }

      this.pageCount.textContent = this.currentPage;
      this.pageTotal.textContent = this.totalPages;
    }

    onButtonClick(event) {
      event.preventDefault();
      const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }

  customElements.define('slider-component', SliderComponent);


  // class SlideshowComponent extends SliderComponent {
  //   constructor() {
  //     super();
  //     this.sliderControlWrapper = this.querySelector('.slider-buttons');
  //     this.enableSliderLooping = true;

  //     if (!this.sliderControlWrapper) return;

  //     this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
  //     if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

  //     this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
  //     this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
  //     this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
  //     this.setSlideVisibility();

  //     if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  //   }

  //   setAutoPlay() {
  //     this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
  //     this.autoplaySpeed = this.slider.dataset.speed * 1000;

  //     this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
  //     this.addEventListener('mouseover', this.focusInHandling.bind(this));
  //     this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
  //     this.addEventListener('focusin', this.focusInHandling.bind(this));
  //     this.addEventListener('focusout', this.focusOutHandling.bind(this));

  //     this.play();
  //     this.autoplayButtonIsSetToPlay = true;
  //   }

  //   onButtonClick(event) {
  //     super.onButtonClick(event);
  //     const isFirstSlide = this.currentPage === 1;
  //     const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

  //     if (!isFirstSlide && !isLastSlide) return;

  //     if (isFirstSlide && event.currentTarget.name === 'previous') {
  //       this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
  //     } else if (isLastSlide && event.currentTarget.name === 'next') {
  //       this.slideScrollPosition = 0;
  //     }
  //     this.slider.scrollTo({
  //       left: this.slideScrollPosition
  //     });
  //   }

  //   update() {
  //     super.update();
  //     this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
  //     this.prevButton.removeAttribute('disabled');

  //     if (!this.sliderControlButtons.length) return;

  //     this.sliderControlButtons.forEach(link => {
  //       link.classList.remove('slider-counter__link--active');
  //       link.removeAttribute('aria-current');
  //     });
  //     this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
  //     this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  //   }

  //   autoPlayToggle() {
  //     this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
  //     this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
  //     this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  //   }

  //   focusOutHandling(event) {
  //     const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
  //     if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
  //     this.play();
  //   }

  //   focusInHandling(event) {
  //     const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
  //     if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
  //       this.play();
  //     } else if (this.autoplayButtonIsSetToPlay) {
  //       this.pause();
  //     }
  //   }

  //   play() {
  //     this.slider.setAttribute('aria-live', 'off');
  //     clearInterval(this.autoplay);
  //     this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  //   }

  //   pause() {
  //     this.slider.setAttribute('aria-live', 'polite');
  //     clearInterval(this.autoplay);
  //   }

  //   togglePlayButtonState(pauseAutoplay) {
  //     if (pauseAutoplay) {
  //       this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
  //       this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
  //     } else {
  //       this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
  //       this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
  //     }
  //   }

  //   autoRotateSlides() {
  //     const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
  //     this.slider.scrollTo({
  //       left: slideScrollPosition
  //     });
  //   }

  //   setSlideVisibility() {
  //     this.sliderItemsToShow.forEach((item, index) => {
  //       const button = item.querySelector('a');
  //       if (index === this.currentPage - 1) {
  //         if (button) button.removeAttribute('tabindex');
  //         item.setAttribute('aria-hidden', 'false');
  //         item.removeAttribute('tabindex');
  //       } else {
  //         if (button) button.setAttribute('tabindex', '-1');
  //         item.setAttribute('aria-hidden', 'true');
  //         item.setAttribute('tabindex', '-1');
  //       }
  //     });
  //   }

  //   linkToSlide(event) {
  //     event.preventDefault();
  //     const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
  //     this.slider.scrollTo({
  //       left: slideScrollPosition
  //     });
  //   }
  // }

  // customElements.define('slideshow-component', SlideshowComponent);
